module.exports = __webpack_public_path__ + "img/5.eddff9be.jpg";